/* global axios */
import ApiClient from './ApiClient';

/**
 * Extrato do agente — cliente a cliente (Portela, 17/10/2026).
 * Fase 2 do ESTUDO-relatorio-por-agente.md.
 *
 * Arquivo NOVO em vez de um método a mais no `reports.js` nativo: arquivo novo
 * não dá conflito de merge no próximo upgrade do Chatwoot, e some sozinho se o
 * patch for removido.
 *
 * `accountScoped` + `apiVersion: 'v2'` montam `/api/v2/accounts/:id/agent_ledger`,
 * que é a rota declarada no routes.rb do fork.
 */
class AgentLedgerAPI extends ApiClient {
  constructor() {
    super('agent_ledger', { accountScoped: true, apiVersion: 'v2' });
  }

  get({ userId, from, to, page = 1, perPage = 25 }) {
    return axios.get(this.url, {
      params: {
        user_id: userId,
        since: from,
        until: to,
        page,
        per_page: perPage,
      },
    });
  }
}

export default new AgentLedgerAPI();
